import { useSelector } from 'react-redux';
import State from 'store/State';

export const useSelectNotifications = () =>
    useSelector((state: State) => state.notification);
